"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ECommunityInvestmentTrads = void 0;
exports.ECommunityInvestmentTrads = {
    reinvestment_of_equity: "Un réemploi de fonds propres",
    mutual_funds: "Des fonds communs",
};
